export default __webpack_public_path__ + "static/media/logo-facebook.106d2ac0.svg";